import { RouteObject } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import { UserDetailsPage, UsersPage } from '~features/users';

const UserRoutes = (): RouteObject[] => {
	return [
		{
			path: pagePathSegments.Users,
			children: [
				{
					index: true,
					element: <UsersPage />,
				},
				{
					path: ':id',
					children: [{ index: true, element: <UserDetailsPage /> }],
				},
			],
		},
	];
};

export default UserRoutes;
